module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tg-4abbb52870d11bce293d114b7fa12619.svg";